module.exports = __webpack_public_path__ + "img/20260309_4.320b210c.jpg";